export const preostudentsubjectApi = {
    heading:[
        {
            head:"Active"
        },
        {
            head:"Subject ID"
        },
        {
            head:"Subject Name"
        },
     
    ],
    data:[
       {
            active:"",
            subjectID:"102",
            subjectname:"English",
       },
       {
            active:"",
            subjectID:"102",
            subjectname:"Math",
       },
       {

       },
       {

       },
       {

       },
       {

       },
       {

       },
       {

       },
       {

       },
       {

       },
       {

       },
     
       
    ]
}
export const preOAssignTeacherforsubApi= {
    heading:[
        {
            head:"SL"
        },
        {
            head:"Subject Name"
        },
        {
            head:"Teacher Name"
        },
        {
            head:"Teacher Percentage"
        },
        {
            head:"Vat"
        },
     
    ],
    data:[
       {
            sl:"1",            
            subjectname:"English",
            teachername:"Akib Raj",
            teacherperventage:"65",
            vat:"7%",
       },
       {
            sl:"1",            
            subjectname:"English",
            teachername:"Akib Raj",
            teacherperventage:"65",
            vat:"7%",
       },
       {
            sl:"1",            
            subjectname:"English",
            teachername:"Akib Raj",
            teacherperventage:"65",
            vat:"7%",
       },
    ]
}